






















































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';
import AgregarPersistente from '@/components/persistentes/AgregarPersistentes.vue';
import ConceptoPersistentes from '@/components/persistentes/ConceptoPersistentes.vue';
import GenerarBorradores from '@/components/persistentes/GenerarBorradores.vue';
import EliminarPersistentes from '@/components/persistentes/EliminarPersistentes.vue';

export default Vue.extend({
  components: { AgregarPersistente, ConceptoPersistentes, GenerarBorradores, EliminarPersistentes },
  data: () => ({
    singleSelect: false,
    row: {},
    selected: [],
    ids: [],
    headers: [
      { text: 'Unidad', value: 'unidad.name', sortable: false  },
      { text: 'Propietario', value: 'propietario.nombre', sortable: false  },
      { text: 'serie', value: 'serie', sortable: false  },
    ],
    total: 0,
    Persistentes: [],
    loading: true,
    options: {
      // page: 1,
      itemsPerPage: 100,
      sortBy: ['unidad.name'],
      sortDesc: [false],
    },
    dialog: false,
    Concepto: {},
    readonly: true,
    isSelectedEmpty: true,
    precision: 2,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getRecurrentesList']),
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const options = this.options;
        const result = await this.$store.dispatch('getRecurrentesList', {admin, condo, options});
        console.log('getRecurrentesList response ', result);
        this.Persistentes = result.content;
        this.total = result.totalElements;
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.selected = [];
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
    verRecibo(item) {
      this.setRecibo(item);
    },
    rowSelected(event) {
      const reciboInArray = this.isReciboInArray(event, this.selected);
      const isInArray = reciboInArray.boolValue;
      const index = reciboInArray.index;
      if (isInArray) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(event);
      }
    },
    isReciboInArray(recibo, recibosArray) {
      const returnObject = {
        boolValue: false,
        index: 0,
      };
      let index = 0;
      for (const rec of recibosArray) {
        if (recibo.id === rec.id) {
          returnObject.boolValue = true;
          returnObject.index = index;
          return returnObject;
        }
        index++;
      }
      returnObject.boolValue = false;
      returnObject.index = -1;
      return returnObject;
    },
    goToBorradores() {
      this.$router.push({ name: 'loteRecibos' });
    },
  },
  watch: {
    selected() {
      if (Array.isArray(this.selected) && this.selected.length === 0) {
        this.ids = [];
        this.isSelectedEmpty = true;
      } else {
        let i = 0;
        this.ids = [];
        for (i = 0; i < this.selected.length; i++) {
          this.ids.push(this.selected[i].id);
        }
        console.log('IDS: %o', this.ids);
        this.isSelectedEmpty = false;
      }
    },
  },
});
